import { isPlainObject, mapKeys, mapValues } from 'lodash';

export const campaignSteps = ['Basic information', 'Content', 'Location', 'Products', 'Duration'];

export const campaignInitialValues = {
  basicInformation: {
    title: '',
    description: '',
    adType: '',
  },
  content: {
    campaignType: '',
    redirectLink: '',
    poll: { question: '', choices: [''], postVotingMessage: ''}
  },
  location: {
    coords: [],
    specialties: [], // {label: string, value: string}
  },
  products: {
    sections: [],
  },
  duration: {
    startDate: '',
    scheduleEndDate: null,
    dovepointsLimit: null,
  }
}

export const objectToFormData = (obj:any, form?:any, namespace?:any) => {
    
  var fd = form || new FormData();
  var formKey;
  
  for(var property in obj) {
    if(obj.hasOwnProperty(property)) {
      
      if(namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }
     
      // if the property is an object, but not a File,
      // use recursivity.
      if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        
        objectToFormData(obj[property], fd, property);
        
      } else {
        
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
      
    }
  }
  
  return fd;
    
};

//@ts-ignore
export const mapKeysDeepLodash = (obj:any, cb:Function, isRecursive?:boolean) => {
  if (!obj && !isRecursive) {
    return {};
  }

  if (!isRecursive) {
    if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean") {
      return {};
    }
  }

  if (Array.isArray(obj)) {
    return obj.map(item => mapKeysDeepLodash(item, cb, true));
  }

  if (!isPlainObject(obj)) {
    return obj;
  }

  const result = mapKeys(obj, cb);

  return mapValues(result, value =>
    mapKeysDeepLodash(value, cb, true)
  );
};
